export default __webpack_public_path__ + "1bfcd71a261e2b79ff336ea86c358c28.png";